<template>
  <DefaultLayout>
    <section>
        <div v-if="successMessage">
            {{ successMessage }}
        </div>
        <div v-if="errorMessage">
            {{ errorMessage }}
        </div>
        <div class="container-form" v-if="invoice_number">
            <div class="title">
                <span>Invoice Details</span>
            </div>
            <div>
                <input
                    v-model="company_name"
                    class="inputs"
                    type="text"
                    placeholder="Company Name"
                    disabled
                >
            </div>
            <div>
                <input
                    v-model="invoice_number"
                    class="inputs"
                    type="text"
                    placeholder="Invoice Number"
                    disabled
                >
            </div>
            <div>
                <input
                    v-model="amount"
                    class="inputs"
                    type="text"
                    placeholder="Amount"
                    disabled
                >
            </div>
            <div>
                <input
                    v-model="transaction_date"
                    class="inputs"
                    type="text"
                    placeholder="Transaction Date"
                    disabled
                >
            </div>
            <div>
                <input
                    v-model="status"
                    class="inputs"
                    type="text"
                    placeholder="Status"
                    disabled
                >
            </div>
            <div>
                <input
                    v-model="transaction_id"
                    class="inputs"
                    type="text"
                    placeholder="Transaction ID"
                    disabled
                >
            </div>
            <div>
                <input
                    v-model="comment"
                    class="inputs"
                    type="text"
                    placeholder="Comment"
                    disabled
                >
            </div>
        </div>
    </section>
  </DefaultLayout>
</template>
<style lang="scss" scoped></style>
<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue';

export default {
  name: 'InvoiceDetails',
  data() {
    return {
      paymentRequestId: '',
      company_name: '',
      invoice_number: '',
      amount: '',
      transaction_date: '',
      status: '',
      transaction_id: '',
      comment: '',
      errorMessage: '',
      successMessage: '',
      generatedLink: '',
    };
  },
  components: {
    DefaultLayout,
  },
  mounted() {
    this.loadPaymentRequest();
  },
  methods: {
    async loadPaymentRequest() {
      this.paymentRequestId = this.$route.params.id;
      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.token}!` },
      };
      fetch(`${process.env.VUE_APP_API_URL}/v1/transactions/show/${this.paymentRequestId}`, requestOptions)
        .then(async (response) => {
          const data = await response.json();

          // check for error response
          if (!response.ok) {
            // get error message from body or default to response status
            const error = (data && data.error) || response.status;
            return Promise.reject(error);
          }
          if (!data.transaction || data.transaction === null) {
            const error = 'Invalid invoice.';
            return Promise.reject(error);
          }
          this.company_name = data.transaction.company_name;
          this.invoice_number = data.transaction.invoice_number;
          this.amount = data.transaction.amount;
          this.transaction_date = data.transaction.transaction_date;
          this.status = data.transaction.status;
          this.transaction_id = data.transaction.transaction_id;
          this.comment = data.transaction?.comment;
          return true;
        })
        .catch((error) => {
          this.errorMessage = error;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.container-form {
  margin-top: 30px;
  min-height: calc(100vh - 83px);
  padding-top: 33px;
  padding: 2rem;
}
</style>
